import { httpClient } from '@/services/http/httpClient'

type CreateIdeaWorkflowStepParams = {
  ideaId: string
  stepId: string
  title: string
}

type CreateIdeaWorkflowStepResponse = {
  id: string
  title: string
  stepId: string
  sequence: number
  ideaId: string
  createdAt: string
  updatedAt: string
}

export const createIdeaWorkflowStep = async ({
  ideaId,
  stepId,
  title,
}: CreateIdeaWorkflowStepParams) => {
  const { data } = await httpClient.post<CreateIdeaWorkflowStepResponse>(
    `/ideas/funnel/steps`,
    {
      ideaId,
      title,
      stepId,
    },
  )

  return data
}
